import * as React from 'react';
import { useContext, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { getSchoolProfile } from '../../services/cps-school-api';
import { getSchoolProgramProfile, getSchoolProgramProfileNew } from '../../services/summer-prog-api';
import { getCelSchoolProfile } from '../../services/prek-school-api';
import { getSchoolTypeFromId } from '../../utility/api-utilities';
import BannerMap from '../info/banner-map';
import { AppContext } from '../school-search-app';
import PrekProfile from './prek-profile';
import ProgramProfile from './program-profile';
import AdmissionsTab from './profile/admissions';
import DownloadsTab from './profile/downloads';
import OverviewTab from './profile/overview';
import ProgramsTab from './profile/programs';
import ReportsTab from './profile/reports';
import CpsProfile from './cps-profile';
import { PrekSchool, Result, PAGE_MODE, SchoolType, SCHOOL_TYPE } from '../../interfaces'
export interface IProfilePageProps {
    schoolId: string,
    close: () => void,
    mode?: string,
    schoolResults: PrekSchool[]
}

function ProfilePage({ schoolId, close, mode, schoolResults }: IProfilePageProps) {
    const [school, setSchool] = useState(null)
    const [schoolType, setSchoolType] = useState(null)
    const appContext = useContext(AppContext)
    const [schooErrorMsg, setSchooErrorMsg] = useState('');
    const setSchoolData = (school: Result, type: SchoolType) => {
        setSchool(school);
        appContext.setBackgroundSchool(school)
        setSchoolType(type);
    }
    React.useEffect(() => {
        let type = PAGE_MODE.CPS;
        if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
            type = SCHOOL_TYPE.SUMMER_PROGRAMM;
        }
        else if (mode) {
            type = mode == PAGE_MODE.GOCPS ? SCHOOL_TYPE.CPS : SCHOOL_TYPE.CEL;
        } else {
            type = getSchoolTypeFromId(schoolId);
        }
        
        if (type == SCHOOL_TYPE.CPS) {
             getSchoolProfile(schoolId).then(result => {
                 setSchoolData(result, SCHOOL_TYPE.CPS as SchoolType)
            }, error => {
                setSchooErrorMsg('Something went wrong, please try refreshing the page.')
            });
        }
        else if (type == SCHOOL_TYPE.CEL) {
             getCelSchoolProfile(schoolId).then(result => {
                 setSchoolData(result, SCHOOL_TYPE.CEL as SchoolType)
              
            }, error => {
                setSchooErrorMsg('Something went wrong, please try refreshing the page.')
            });
        }

    }, []);
    React.useEffect(() => {
        if (schoolId && (schoolResults && schoolResults.length > 0) && appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
            const school = getSchoolProgramProfileNew(schoolResults, schoolId);
            setSchoolData(school._epi, SCHOOL_TYPE.SUMMER_PROGRAMM as SchoolType)
        }
        
    }, [schoolResults]);

    let cpsProfile;
    if (appContext.mode != PAGE_MODE.SUMMER_PROGRAMM) {
        cpsProfile = (s) => {
            return <>
                <div className="padded-page-header">
                    <BannerMap school={school} height="225px" />
                </div>
                {school.alertMessage && <div className="school-alert" dangerouslySetInnerHTML={{ __html: school.alertMessage }}></div>}
                <div className="bs-shim bs-nav">
                    {appContext.mode !== PAGE_MODE.GOCPS
                        ? <CpsProfile school={school} />

                        : <Tabs fill defaultActiveKey="overview" >

                            <Tab key="overview" eventKey="overview" title="Overview">
                                <OverviewTab school={school} />
                            </Tab>
                            <Tab key="reports" eventKey="reports" title="Reports">
                                <ReportsTab school={school} />
                            </Tab>
                            <Tab key="admissions" eventKey="admissions" title="Admissions">
                                <AdmissionsTab school={school} />
                            </Tab>
                            <Tab key="programs" eventKey="programs" title="Programs">
                                <ProgramsTab school={school} />
                            </Tab>
                            <Tab key="downloads" eventKey="downloads" title="Downloads">
                                <DownloadsTab school={school} />
                            </Tab>
                        </Tabs>
                    }

                </div></>
        }
    }

    const celProfile = (s) => {
        return <PrekProfile school={s} />
    }
    const programProfile = (s) => {
        return <ProgramProfile school={s} />
    }

    let body = <div className="loadingGif_container loading_profile"><img src="https://www.cps.edu/globalassets/cps-global-media/icons/spinner.gif" /></div>;

    if (schoolType && school) {
        if (schoolType == SCHOOL_TYPE.CEL) {
            body = celProfile(school);
        }
        else if (schoolType == SCHOOL_TYPE.SUMMER_PROGRAMM) {
            body = programProfile(school);
        }
        else {
            body = cpsProfile(school);
        }
    }

    if (schooErrorMsg !== '') {
        body = <div className="errorMessage">{schooErrorMsg}</div>;
    }

    let classes = "page-close-bar";
    if (schoolType == SCHOOL_TYPE.CEL) {
        classes += ` ${SCHOOL_TYPE.CEL}`;
    }
    else if (schoolType == SCHOOL_TYPE.CPS) {
        classes += ` ${SCHOOL_TYPE.CPS}`;

        if (appContext.mode == PAGE_MODE.GOCPS) {
            if (school.isHighSchool) {
                classes += " hs";
            }
            else {
                classes += " es";
            }
        }
    }
    else if (schoolType == SCHOOL_TYPE.SUMMER_PROGRAMM) {
        classes += ` ${SCHOOL_TYPE.SUMMER_PROGRAMM}` ;
    }

    return <div className="profile-page">
        <div className={`${classes}`}>
            <div className="shortName">{school && school.schoolShortName}</div>
            <button className="btn close-btn" onClick={close}></button>
        </div>
        {body}
    </div>
}

export default ProfilePage;